module.exports = __webpack_public_path__ + "static/img/userule3.b23045d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userule3.jpg
// module id = CBfe
// module chunks = 0